import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import {
    Box, Button, Container, TextField, Typography, Alert, Stack, Paper, Link,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import api from '../api/axios';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); setError('');
        try {
            const { data } = await api.post('/auth/login', { email, password });
            localStorage.setItem('accessToken', data.access);
            localStorage.setItem('refreshToken', data.refresh);
            localStorage.setItem('user', JSON.stringify(data.user));
            navigate('/panel');
        } catch (err) {
            const status = err?.response?.status;
            setError(
                status === 429 ? 'Demasiados intentos. Espera un minuto e intenta de nuevo.'
                    : err?.response?.data?.message ?? 'Error al iniciar sesión'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: '#f8fafc' }}>
            <Container maxWidth="xs">
                <Paper variant="outlined" sx={{ p: 4 }}>
                    <Stack spacing={3}>
                        <Stack spacing={1} alignItems="center">
                            <Box sx={{ width: 48, height: 48, borderRadius: '50%', display: 'grid', placeItems: 'center', bgcolor: 'primary.main', color: '#fff' }}>
                                <LockOutlinedIcon />
                            </Box>
                            <Typography component="h1" variant="h5" sx={{ fontWeight: 700 }}>Área privada</Typography>
                            <Typography variant="body2" color="text.secondary">Solicitudes de contacto</Typography>
                        </Stack>
                        {error && <Alert severity="error">{error}</Alert>}
                        <Box component="form" onSubmit={handleSubmit} noValidate>
                            <Stack spacing={2}>
                                <TextField label="Email" type="email" autoComplete="username" value={email}
                                    onChange={(e) => setEmail(e.target.value)} required fullWidth />
                                <TextField label="Contraseña" type="password" autoComplete="current-password" value={password}
                                    onChange={(e) => setPassword(e.target.value)} required fullWidth />
                                <Button type="submit" variant="contained" size="large" fullWidth disabled={loading}>
                                    {loading ? 'Cargando...' : 'Entrar'}
                                </Button>
                            </Stack>
                        </Box>
                        <Link component={RouterLink} to="/" variant="body2" align="center" underline="hover">
                            ← Volver al portafolio
                        </Link>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}
